import { useEffect, useState } from 'react';

/**
 * usePlanComparison — GOV13-A6. Fetches the catalogue-derived public plan-COMPARISON projection from
 * GET /api/v1/billing/plans/comparison (server-authoritative, sourced from commercial_plan_versions +
 * canonical feature/integration catalogues). The client renders inclusion/limits/integrations purely by
 * looking up the server-provided key sets; it never decides inclusion, price or eligibility. On failure the
 * comparison is simply not shown (no invented data).
 */
export function usePlanComparison() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/v1/billing/plans/comparison`)
      .then(r => (r.ok ? r.json() : Promise.reject(new Error('comparison fetch failed'))))
      .then(d => { if (!cancelled) { setData(d); setLoading(false); } })
      .catch(e => { if (!cancelled) { setError(e); setLoading(false); } });
    return () => { cancelled = true; };
  }, []);

  return { data, loading, error };
}

export default usePlanComparison;
